import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { Stand } from './models';
import {
  CheckOutStandsPayload,
  CreateStandPayload,
  RequestPayload,
  UpdateStandModelPayload,
  UpdateStandPayload,
  EndVisitStandsPayload,
  CreateDMPTypesPayload,
  UpdateDMPTypesPayload,
  CreateDMPGroupsPayload,
  UpdateDMPGroupsPayload,
  StandVisitPayload,
} from './types';
const ENDPOINT = 'stands/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getStands: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Stand>>>(ENDPOINT + 'list/', payload, config),
  createStand: (payload: CreateStandPayload) =>
    instance.post(ENDPOINT + 'create/', payload, config),
  checkOutStands: (payload: CheckOutStandsPayload) =>
    instance.post(ENDPOINT + 'check_out/', payload, config),
  updateStand: (payload: UpdateStandPayload) =>
    instance.put(ENDPOINT + 'update/', payload, config),
  visitStands: (payload: StandVisitPayload) =>
    instance.post(ENDPOINT + 'visit/', payload, config),
  getStandModels: (payload: RequestPayload) =>
    instance.post(ENDPOINT + 'model/list/', payload, config),
  updateStandModel: (payload: UpdateStandModelPayload) =>
    instance.put(ENDPOINT + 'model/update/', payload, config),
  getStandModelQRCode: () =>
    instance.get<ApiResponse<any>>(ENDPOINT + 'model/qrcode/', config),
  getStandModelTemp: () =>
    instance.get<ApiResponse<number[]>>(ENDPOINT + 'model/temp/', config),
  getDMPTypes: (payload: RequestPayload) =>
    instance.post(ENDPOINT + 'dmp/type/list/', payload, config),
  createDMPType: (payload: CreateDMPTypesPayload) =>
    instance.post(ENDPOINT + 'dmp/type/create/', payload, config),
  updateDMPType: (payload: UpdateDMPTypesPayload) =>
    instance.put(ENDPOINT + 'dmp/type/update/', payload, config),
  getDMPGroups: (payload: RequestPayload) =>
    instance.post(ENDPOINT + 'dmp/group/list/', payload, config),
  createDMPGroup: (payload: CreateDMPGroupsPayload) =>
    instance.post(ENDPOINT + 'dmp/group/create/', payload, config),
  updateDMPGroup: (payload: UpdateDMPGroupsPayload) =>
    instance.put(ENDPOINT + 'dmp/group/update/', payload, config),
});
